var _g, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProdejnyMapPathFlorencie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "122px",
    height: "215.292px",
    viewBox: "-28.667 -21.208 122 215.292",
    enableBackground: "new -28.667 -21.208 122 215.292",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    d: "M25.104,136.12 c0.604-0.397,1.441-0.788,2.474-1.186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeDasharray: "5.3936,5.3936",
    d: " M32.708,133.282c25.48-7.356,94.012-20.765,28.094-97.229C43.309,15.762,35.052-0.347,31.693-8.118"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    d: "M30.665-10.607 c-0.661-1.685-0.934-2.582-0.934-2.582"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M28.385,136.8c0.929-1.259,0.659-3.031-0.601-3.957c-1.258-0.931-3.028-0.662-3.959,0.596 c-0.932,1.258-0.66,3.029,0.598,3.961C25.683,138.327,27.455,138.06,28.385,136.8"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    cx: 28.702,
    cy: -18.018,
    r: 2.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdejnyMapPathFlorencie);
export default __webpack_public_path__ + "static/media/prodejny_map_path_florencie.4871dcfe530ae4880514a3ef8ed92a64.svg";
export { ForwardRef as ReactComponent };